var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',[_c('h1',[_vm._v("Page Not Found!")]),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }